<template>
    <div class="card mb-3" style="min-height: 90vh;">
        <div class="card-body row">
            <Loading v-if="showLoading" />
            <div class="col-12">
                <div class="row m-0">
                    <div class="col-9" style="display: flex; align-items: center;">
                        <h3 class="ml-2 my-4">اطلاعات شارژ کارت</h3>
                        <span
                            :class="
                                `badge ml-2 my-4  ${
                                    chargeData.status == 2
                                        ? 'badge-success'
                                        : chargeData.status == 3
                                        ? 'badge-danger'
                                        : 'badge-warning'
                                }`
                            "
                        >
                            {{ chargeData.statusTitle }}
                        </span>
                    </div>

                    <div
                        class="col-12 mb-4"
                        v-if="$store.state.role == 'finance' && chargeData.status == 1"
                        style="display:flex ; align-items: center; justify-content: end;"
                    >
                        <button v-on:click="approveCharge()" class="btn btn-success px-3 py-2 mr-1">
                            <i class="ti-credit-card mx-2"></i>
                            تایید
                        </button>
                        <button
                            data-toggle="modal"
                            :data-target="'#modal-description'"
                            class="btn btn-danger px-3 py-2 mr-1"
                        >
                            <i class="ti-credit-card mx-2"></i>
                            عدم تایید
                        </button>
                    </div>
                </div>
                <div
                    class="modal effect-scale col-md-12"
                    :id="'modal-description'"
                    aria-hidden="true"
                >
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content modal-content-demo">
                            <div class="modal-header">
                                <h6>لطفا توضیحات خود را وارد نمایید</h6>
                                <button
                                    aria-label="بستن"
                                    class="close"
                                    data-dismiss="modal"
                                    type="button"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="row m-0" style="display: flex;">
                                <form
                                    class="form-group col-12"
                                    style="margin-top: 16px;"
                                    v-on:submit.prevent="rejectCharge"
                                >
                                    <div class="form-group col-6">
                                        <label> توضیحات </label>
                                        <input
                                            class="form-control"
                                            style="min-height: 100px;"
                                            v-model="description"
                                        />
                                    </div>
                                    <div
                                        class="col-12"
                                        style="display: flex; justify-content: end;"
                                    >
                                        <button
                                            :disabled="!description"
                                            type="submit"
                                            class="btn btn-success w-25 my-4 px-3 py-2 mr-1"
                                        >
                                            <i class="ti-tick text-white">تایید </i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m-0">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-6 px-2 py-1 border-0">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> مبلغ</b>
                                                </td>
                                                <td>
                                                    <b v-if="chargeData.amount"
                                                        >{{
                                                            new Intl.NumberFormat("en-IR", {
                                                                maximumSignificantDigits: 20
                                                            }).format(chargeData.amount)
                                                        }}
                                                        ریال
                                                    </b>
                                                    <b v-else> - </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> تاریخ ایجاد </b></td>
                                                <td>
                                                    <b>
                                                        {{ chargeData.insertDate || "-" }}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> تاریخ پرداخت </b></td>
                                                <td>
                                                    <b>
                                                        {{ chargeData.paymentDate || "-" }}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> نمایش تاریخچه</b></td>
                                                <td>
                                                    <b>
                                                        <button
                                                            class="btn btn-primary ml-2"
                                                            @click="getHistory"
                                                        >
                                                            <i class="ti-download m-1 "> </i>
                                                            دریافت
                                                        </button>
                                                    </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-6 px-2 py-1 border-0">
                                <div class="table-responsive">
                                    <table class="table main-table-reference text-nowrap my-0">
                                        <tbody>
                                            <tr>
                                                <td class="bg-gray-100"><b> شناسه پرداخت </b></td>
                                                <td>
                                                    <b>
                                                        {{ chargeData.refrenceCode || "-" }}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100" width="40%">
                                                    <b> نام سازمان</b>
                                                </td>
                                                <td>
                                                    <b>{{ chargeData.comanyName || "-" }} </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> نام سوییچ </b></td>
                                                <td>
                                                    <b>
                                                        {{ chargeData.switchName || "-" }}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray-100"><b> تصویر فیش </b></td>
                                                <td>
                                                    <b>
                                                        <button
                                                            :disabled="!chargeData.imageFile"
                                                            class="btn btn-primary ml-2"
                                                            @click="
                                                                (e) =>
                                                                    downloadFile(
                                                                        e,
                                                                        chargeData.imageFile
                                                                    )
                                                            "
                                                        >
                                                            <i class="ti-download m-1 "> </i>
                                                            دانلور تصویر
                                                        </button>
                                                    </b>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-4 px-2" v-if="historyData.length > 0">
                            <label class="tx-md-semibold "> تاریخچه: </label>
                            <div class="row">
                                <DataTable
                                    hasNoPagination="true"
                                    :columns="columns"
                                    :rows="historyData"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="chargeData.status == 4 && chargeData.description" class="col-12 ">
                    <i class="ti-alert" style="color: red; height: 2px;"></i>
                    <span style="color: red; height: 2px;">{{ chargeData.description }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Detail",
    data() {
        return {
            columns: [
                {
                    title: "نام کاربر",
                    field: "userFullName"
                },
                {
                    title: "تاریخ",
                    field: "insertDate"
                },
                {
                    title: "توضیحات",
                    field: "description"
                },
                {
                    title: "وضعییت",
                    field: "statusTitle"
                }
            ],
            chargeData: {},
            historyData: [],
            statusList: [],
            documents: [],
            description: null,
            showLoading: true,
            dialog: false
        };
    },

    methods: {
        getHistory() {
            this.showLoading = true;
            this.$api
                .post(
                    "Organizations/OrganizationChargeWallet/GetHistoryCreditChargeOrganizations",
                    {
                        id: parseInt(this.$route.params.id)
                    }
                )
                .then(({ data }) => {
                    this.historyData = data.result.data;
                })
                .catch(() => {
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: "مجددا اقدام کنید!"
                    });
                });
            this.showLoading = false;
        },
        downloadFile(e, photo) {
            e.preventDefault();
            let a = window.document.createElement("a");
            a.setAttribute("href", photo);
            a.setAttribute("download", "image.png");
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        async rejectCharge() {
            this.showLoading = true;
            this.$api
                .post("Organizations/OrganizationChargeWallet/RejectChargeCreditOrganization", {
                    id: parseInt(this.$route.params.id),
                    description: this.description
                })
                .then(({ data }) => {
                    if (data.status) {
                        location.reload();
                    }
                })
                .catch(() => {
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: "مجددا اقدام کنید!"
                    });
                });
            this.showLoading = false;
        },
        async approveCharge() {
            this.$dialog.confirm("آیا از تایید این درخواست اطمینان دارید ؟ ").then((dialog) => {
                this.showLoading = true;
                this.$api
                    .post("Organizations/OrganizationChargeWallet/ChargeCreditOrganization", {
                        id: parseInt(this.$route.params.id)
                    })
                    .then(({ data }) => {
                        if (data.status) {
                            this.getData();
                        }
                    })
                    .catch(() => {
                        this.$swal({
                            title: "ناموفق",
                            icon: "error",
                            text: "مجددا اقدام کنید!"
                        });
                    })
                    .finally(() => {
                        this.showLoading = false;
                        if (dialog) {
                            dialog.close();
                        }
                    });
            });
        },
        async getData() {
            this.showLoading = true;
            const body = {
                id: parseInt(this.$route.params.id)
            };
            this.$api
                .post(
                    "Organizations/OrganizationChargeWallet/GetCreditChargeOrganizationById",
                    body
                )
                .then(({ data }) => {
                    if (data.status) {
                        this.showLoading = false;
                        this.chargeData = data.result.data;
                    }
                    this.showLoading = false;
                })
                .catch(() => {
                    this.showLoading = false;
                    this.$swal({
                        title: "ناموفق",
                        icon: "error",
                        text: " داده ای  یافت نشد ,لذا مجدد اقدام کنید!"
                    });
                });
        }
    },
    created() {
        this.getData();
    }
};
</script>
